/* eslint-disable @typescript-eslint/camelcase */
import { Component } from 'vue-property-decorator'
import { FormStructure, TableFormStructure } from '@master/model/structure/FormStructure'
import { FormBaseMixin } from './FormBaseMixin'
import { AcademicQualification, Employment, NationalServiceDetails, OtherProfessionalQualification, QualiEmployFields, QualificationEmployment } from '@core/model/recruit/forms/QualificationEmployment'
import { getClone, getMaxSize } from '@core/annotation/ExpandableArray'
import { isUndefined } from 'lodash/fp'
import { getOptions } from '@core/annotation/Selection'
import { tableTypeConsumerFactory } from 'vuejs-datatable/dist/components/mixins/table-type-consumer-factory'
import { namespace } from 'vuex-class'
import ActivityCard from '@core/pages/activity/model/ActivityCard'

const activityStore = namespace('ActivityStore')
@Component
export class QualificationEmploymentMixin extends FormBaseMixin {
  @activityStore.State
  private activities: ActivityCard[]

  @activityStore.Mutation
  private resetActivities

  protected type = QualificationEmployment

  get fields (): QualiEmployFields {
    return this.formData.data as QualiEmployFields
  }

  get nsNotApplicable () {
    return this.fields?.nationalService?.notApplicable
  }

  set nsNotApplicable (val) {
    (this.formData.data as QualiEmployFields).nationalService.notApplicable = val
  }

  get nsInfoStructure (): FormStructure<NationalServiceDetails> {
    return [
      {
        label: 'Service Status',
        key: 'status',
        type: 'smart',
        disabled: this.nsNotApplicable,
        options: getOptions(this.fields.nationalService, 'status')
      },
      {
        label: 'Enlistment Date',
        key: 'enlistmentDate',
        disabled: this.nsNotApplicable,
        type: 'date'
      },
      {
        label: 'ORD Date',
        key: 'ordDate',
        disabled: this.nsNotApplicable,
        type: 'date'
      }
    ]
  }

  get academicCols (): TableFormStructure<AcademicQualification> {
    return [
      { label: 'From', key: 'from', tip: '(MM/YYYY)', type: 'text' },
      { label: 'To', key: 'to', tip: '(MM/YYYY)', type: 'text' },
      { label: 'Academic Qualification', tip: '(GCE ‘A’, Diploma, Degree)', key: 'title', type: 'text' },
      { label: 'Name of Institution', key: 'institute', type: 'text' }
    ]
  }

  get academicErrors () {
    return this.formDataErrors.find(err => err.key === 'academic')?.msgs
  }

  get cmfasInfoStructure (): FormStructure<QualiEmployFields> {
    return [
      {
        label: 'SCI CMFAS Qualifications',
        key: 'professional',
        type: 'smart',
        multiple: true,
        optionCols: 4,
        cycleMode: true,
        options: getOptions(this.fields, 'professional')
      }
    ]
  }

  async getActivity () {
    await this.resetActivities()
    await this.$api.activity.search({ accountOid: this.recruitAccountOid })
  }

  get otherQualiCols (): TableFormStructure<OtherProfessionalQualification> {
    return [
      { label: 'Date of Attainment', key: 'attain', tip: '(MM/YYYY)', type: 'text' },
      { label: 'Professional Qualification', key: 'title', type: 'text' },
      { label: 'Name of Professional Body', key: 'body', type: 'text' }
    ]
  }

  get employCols (): TableFormStructure<Employment> {
    return [
      { label: 'From', key: 'from', tip: '(MM/YYYY)', type: 'month' },
      { label: 'To', key: 'to', tip: '(MM/YYYY)', type: 'month' },
      { label: 'Employer', key: 'employer', type: 'text' },
      { label: 'Last Position Held', key: 'position', type: 'text' },
      {
        label: 'Nature of Employment',
        tip: '(Full-time, Part-time, Contract, Internship, Temporary)',
        key: 'nature',
        type: 'dropdown',
        options: getOptions(this.fields.employment[0], 'nature')
      },
      { label: 'Reason for Leaving', tip: '(Voluntary/Involuntary)', key: 'reason', type: 'text' }
    ]
  }

  get maxEmploySize () {
    return getMaxSize(this.fields, 'employment')
  }

  addEmployment () {
    const cloneFunction = getClone(this.fields, 'employment')
    this.fields.employment.push(cloneFunction())
  }

  removeEmployment (idx) {
    const isNotEmpty = Object.values(this.fields.employment[idx]).some(val => !isUndefined(val) && val.length > 0)
    if (isNotEmpty) {
      if (!confirm('Data is found. Confirm remove row ?')) return
    }
    this.fields.employment.splice(idx, 1)
  }
}
